import React from "react";

const Modal = ({ modalTitle, children, modalId }) => {
  return (
    <>
      <div
        class="modal fade"
        id={modalId}
        tabindex="-1"
        role="dialog"
        aria-labelledby={modalId}
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id={modalId}>
                {modalTitle}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Modal };
